// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 806 ? "4163ae0c" : chunkId) + "." + {"806":"bf7ece7916944946","4208":"cea0472d55f49ab9","4439":"c69068b20f66540f"}[chunkId] + ".js";
};